import React from "react";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  parallaxLayer: {
    //parallax
    // position: 'absolute',
    // top: 0,
    // right: 0,
    // bottom: 0,
    // left: 0,
  },
  parallexContainer: {
    perspective: 100,
    height: "100vh",
    overflowX: "hidden",
    overflowY: "auto",
    // backgroundColor: 'white',

    // link hover and click not working on firefox  because of zIndex
    // TODO: find solution for this for whole page background image
    // zIndex: '-10'

    // position: 'absolute',
    // top: 0,
    // left: 0,
    // right: 0,
    // bottom: 0,
  },
  indexMainContainer: {
    // marginTop: '100vh', //'calc(100vh - 100px)',
    position: "relative",
    backgroundColor: "white",
    //  padding: '40px 0px',
    "&> div": {
      position: "relative",
      backgroundColor: "white",
      padding: "20px 50px",
      [theme.breakpoints.down("sm")]: {
        padding: "40px 20px",
      },
    },
  },
  highlightButton: {
    backgroundColor: "white",
    color: theme.palette.primary.main, //'#6c4553',
    margin: "auto",
  },
  activeNavItem: {},
  otherButton: {
    backgroundColor: theme.palette.primary.main, //`${theme.palette.primary.main}`,
    color: theme.palette.text.primary, //'white',
    // border: '2px solid white',
    margin: `${theme.spacing(2)}px auto`,
    borderRadius: 5,
    "&:hover": {
      backgroundColor: theme.palette.primary.main, //`${theme.palette.primary.main}`,
      color: theme.palette.text.primary, //'white',
      boxShadow:
        "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
      // border: 'none'
    },
  },
  disableButton: {
    backgroundColor: "grey",
  },
  buttonText: {
    textTransform: "none",
    fontSize: "1.2rem",
    color: theme?.agentTheme?.primary?.foreground,
  },
  floatingIcon: {
    position: "fixed",
    zIndex: 2,
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    // padding:20
  },
  whatsappFloatingButton: {
    backgroundColor: "#52d367",
    "&:hover": {
      backgroundColor: "#52d367",
    },
  },
}));
